<template>
  <div>
    <v-dialog v-model="hideShow" width="760px" persistent scrollable content-class="student-edit-dialog" aria-label="修改学员资料">
      <v-card class="se-shell">
        <v-card-title class="se-header">
          <span class="se-symbol"><v-icon size="26" color="#d9363e">mdi-account-edit-outline</v-icon></span>
          <div><h2>修改学员资料</h2><p>完善学员档案与联系信息</p></div>
          <v-spacer />
          <v-btn icon aria-label="关闭修改学员资料" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="se-body">
          <template v-if="update.student">
            <section class="se-section" aria-labelledby="se-basic-heading">
              <div class="se-section-heading"><h3 id="se-basic-heading">基本信息</h3><span><b>*</b> 为必填项</span></div>
              <div class="se-fields">
                <v-text-field v-model="update.student.studentName" label="学员姓名 *" placeholder="请输入学员姓名" dense outlined hide-details color="#d9363e" />
                <div class="se-gender"><v-radio-group label="性别 *" v-model="update.student.gender" row hide-details class="ma-0"><v-radio label="男生" value="1" color="#d9363e" /><v-radio label="女生" value="0" color="#d9363e" /></v-radio-group></div>
                <div class="se-option"><v-select v-model="update.student.studentSource" :items="studentSourceItems" label="生源类型" item-text="sourceName" item-value="id" dense outlined hide-details color="#d9363e" /><v-btn text class="se-option-add" color="#b92e36" aria-label="添加生源类型" @click="showCreateSource('1')"><v-icon small>mdi-plus</v-icon>添加</v-btn></div>
              </div>
            </section>
            <section class="se-section" aria-labelledby="se-contact-heading">
              <div class="se-section-heading"><h3 id="se-contact-heading">联系信息</h3></div>
              <div class="se-fields">
                <v-text-field v-model="update.student.contactorCall" label="联系人关系" placeholder="如：爸爸 / 妈妈 / 本人" dense outlined hide-details color="#d9363e" />
                <v-text-field v-model="update.student.contactorMobile" label="联系人手机" placeholder="请输入联系人手机号" dense outlined hide-details color="#d9363e" />
              </div>
            </section>
            <section class="se-section" aria-labelledby="se-extra-heading">
              <div class="se-section-heading"><h3 id="se-extra-heading">补充资料</h3><span>选填，可稍后完善</span></div>
              <div class="se-fields">
                <v-menu ref="menuBirthday2" v-model="update.menuBirthday" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }"><v-text-field v-model="update.student.birthday" label="学员生日" placeholder="选择出生日期" readonly v-bind="attrs" v-on="on" dense clearable outlined hide-details color="#d9363e" append-icon="mdi-calendar-blank-outline" /></template>
                  <v-date-picker v-model="update.student.birthday" @input="update.menuBirthday=false" locale="zh-cn" no-title scrollable color="#d9363e" />
                </v-menu>
                <div class="se-avatar"><cutImageUpload :show="hideShow" title="修改学员头像" :previewImg="update.student.avatar" :waterText="update.student.studentName" @success="uploadSuccess" /></div>
                <div class="se-option"><v-select v-model="update.student.fromSchool" :items="fromSchoolItems" label="就读学校" item-text="sourceName" item-value="id" dense outlined hide-details color="#d9363e" /><v-btn text class="se-option-add" color="#b92e36" aria-label="添加就读学校" @click="showCreateSource('2')"><v-icon small>mdi-plus</v-icon>添加</v-btn></div>
                <div class="se-option"><v-select v-model="update.student.fromRegion" :items="fromRegionItems" label="居住片区" item-text="sourceName" item-value="id" dense outlined hide-details color="#d9363e" /><v-btn text class="se-option-add" color="#b92e36" aria-label="添加居住片区" @click="showCreateSource('3')"><v-icon small>mdi-plus</v-icon>添加</v-btn></div>
                <v-text-field v-model="update.student.idCardNo" label="身份证号" placeholder="请输入身份证号" dense outlined hide-details color="#d9363e" />
                <v-text-field v-model="update.student.homeAddress" label="家庭住址" placeholder="请输入家庭住址" dense outlined hide-details color="#d9363e" />
              </div>
            </section>
          </template>
        </v-card-text>
        <v-card-actions class="se-footer">
          <v-spacer />
          <v-btn outlined color="#586a80" @click="cancel">取消</v-btn>
          <v-btn depressed color="#d9363e" dark @click="submitUpdate">保存修改</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <createStudentSource :show="createSourceShow" :dataType="createSourceDataType" @cancel="createSourceShow=false" @success="createSourceSuccess" />
  </div>
</template>


<script>
	import utils from "../config/utils"
	import uploadPhoto from "./upload_photo.vue"
	import createStudentSource from "./create_student_source.vue"
	import cutImageUpload from "./cut_image_upload.vue"
	export default {
		name:"update-student",
		components:{uploadPhoto,createStudentSource,cutImageUpload},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			student:{
				type:Object,
				default:null
			},
		},
		watch:{
			show(newVal,oldVal){
				this.hideShow = newVal;
				console.log("update student show=",newVal);
				if(this.hideShow){
					
					console.log(this.student);
					
					this.update.student.id = this.student.id;
					this.update.student.studentName = this.student.studentName;
					this.update.student.gender = this.student.gender;
					this.update.student.birthday = this.student.birthday;
					this.update.student.avatar = this.student.avatar;
					this.update.student.contactorCall = this.student.contactorCall;
					this.update.student.contactorMobile = this.student.contactorMobile;
					this.update.student.homeAddress = this.student.homeAddress;
					this.update.student.studentSource = this.student.studentSource;
					this.update.student.fromSchool = this.student.fromSchool;
					this.update.student.fromRegion = this.student.fromRegion;
					this.update.student.idCardNo = this.student.idCardNo;
					

				}
				
			}
		},
		data(){
			return {
				shopId:"",
				update: {
					menuBirthday: false,
					student:{
						id: "",
						studentName: "",
						gender: "",
						avatar: "",
						birthday: "",
						contactorCall: "",
						contactorMobile: "",
						homeAddress: "",
						studentSource:"",
						fromSchool:"",
						fromRegion:"",
						idCardNo:""
					},
				},
				hideShow:this.show,
				studentSourceItems:[],
				createSourceShow:false,
				createSourceDataType:"",
				fromSchoolItems:[],
				fromRegionItems:[]
				
			}
		},
		mounted() {
			this.shopId = utils.getCurrentShopId();
			//this.getShopListForSelect();
			console.log("update-student mounted");
			this.getStudentSourceList('1');
			this.getStudentSourceList('2');
			this.getStudentSourceList('3');
		},
		methods:{
			uploadSuccess(e){
				console.log("修改学员头像成功",e);
				this.update.student.avatar = e.key;
			},
			
			submitUpdate() {
			
				if (!this.update.student.studentName) {
					this.$noty.error('姓名不能为空');
					return
				}
				if (!this.update.student.gender) {
					this.$noty.error('性别不能为空');
					return
				}
		
				// api
				const that = this;
				let url = `/edu/student/update`;
			
				// parameters
				const updateData = {
					...this.update.student
				}

				this.axios.post(url, updateData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							
							that.$emit("success","");
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
			
				});
			},
			cancel(){
				this.$emit("cancel","");
			},
			getStudentSourceList(dataType){
				
				// api
				const that = this;
				let url = `/edu/shop/student/source/list/${this.shopId}/${dataType}`;	
				this.axios.get(url).catch(() => {
					
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							
							const result = res.data["data"]||[];
							
							if (dataType=='1'){
								that.studentSourceItems = result;
							}else if (dataType=='2'){
								that.fromSchoolItems = result;
							}else if (dataType=='3'){
								that.fromRegionItems = result;
							}
							
							return;
						} 
					} 
							
				});
			},
			showCreateSource(dataType){
				this.createSourceDataType = dataType;
				this.createSourceShow = true;
			},
			createSourceSuccess(){
				this.getStudentSourceList(this.createSourceDataType);
				this.createSourceShow = false;
			}
		}
	}
	
</script>

<style lang="scss" scoped src="../assets/styles/student-edit.scss"></style>
